import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { TaControlRoutingModule } from './tacontrol-routing.module';
import { TaControlComponent } from './tacontrol.component';
import { WtGroupComponent } from './wtgroup/wtgroup.component';
import { BalanceCutComponent } from './balancecut/balancecut.component';
import { OvertimeRuleComponent } from './overtimerule/overtimerule.component';
import { BalanceCalcComponent } from './balancecalc/balancecalc.component';
import { CalendarRuleComponent } from './calendarrule/calendarrule.component';
import { CalendarRuleService } from '../services/calendarrule.service';
import { CalRuleDlyProgService } from '../services/calruledlyprog.service';
import { BalCalcRuleService } from '../services/balcalcrule.service';
import { OverTimeRuleService } from '../services/overtimerule.service';
import { SalPeriodGroupService } from '../services/salprdgrp.service';
import { BalanceCutService } from '../services/balancecut.service';
import { SaldoNumberService } from '../services/saldonumber.service';
import { SaldoRelationService } from '../services/saldorelation.service';
import { DailyProgramService } from '../services/dailyprogram.service';
import { WeekdayTypeService } from '../services/weekdaytype.service';
import { RsncdDlyProgService } from '../services/rsncddlyprog.service';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    SharedModule,
    TaControlRoutingModule
 
  ],
  declarations: [
    TaControlComponent,
    WtGroupComponent,
    BalanceCutComponent,
    BalanceCalcComponent,
    OvertimeRuleComponent,
    CalendarRuleComponent
    //TabasetableDialogComponent,
    //AbsenceCodeEditorComponent,
    //WorkNumberEditorComponent,
    //TaBasetableComponent
  ],
  providers: [
    CalendarRuleService,
    BalCalcRuleService,
    OverTimeRuleService,
    SalPeriodGroupService,
    BalanceCutService,
    SaldoNumberService,
    SaldoRelationService,
    CalRuleDlyProgService,
    DailyProgramService,
    WeekdayTypeService,
    RsncdDlyProgService
    //AcceptLevelService,
    //SaldoTypeService,
    //CalcRuleService,
    //WorkNumberService,
    //AbsenceCodeService
/*    TaBasetableService*/
  ]
})
export class TaControlModule {
}
